import { render, staticRenderFns } from "./GptAdModal.vue?vue&type=template&id=5137c72f&scoped=true"
import script from "./GptAdModal.vue?vue&type=script&lang=js"
export * from "./GptAdModal.vue?vue&type=script&lang=js"
import style0 from "./GptAdModal.vue?vue&type=style&index=0&id=5137c72f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5137c72f",
  null
  
)

export default component.exports